import { Box } from '@mui/material';

import { Lock01Icon } from '@/components/icons/Lock01Icon';
import { COLORS } from '@/styles/tokens/colors';

interface ProUpsellIconProps {
  size?: number;
}

export function ProUpsellIcon({ size = 15 }: ProUpsellIconProps) {
  return (
    <Box
      sx={{
        padding: '1px',
        height: size + 3,
        width: size + 3,
        backgroundColor: COLORS.ORANGE[100],
        borderRadius: '50%',
      }}
    >
      <Lock01Icon size={size} color={COLORS.ORANGE[500]} />
    </Box>
  );
}
